module.exports = {"name":"Season :season","name_med":":expansion Season :season","name_long":":expansion Season :season"};